var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJurorFeedback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.58655,
    width: 9.14494,
    height: 11.9135,
    stroke: "#3C41B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2002 4.33138L2.8242 4.99995L4.13162 3.69995",
    stroke: "#3C41B2",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9248 4.69995H6.6748",
    stroke: "#3C41B2",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01855 7.94995H8.08105",
    stroke: "#3C41B2",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2002 7.33138L2.8242 7.99995L4.13162 6.69995",
    stroke: "#3C41B2",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01855 10.95H8.08105",
    stroke: "#3C41B2",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2002 10.3314L2.8242 11L4.13162 9.69995",
    stroke: "#3C41B2",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5796 0L6.45166 5.07642L7.87231 6.48291L13.0002 1.40613L11.5796 0Z",
    fill: "#3C41B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75439 7.17474L7.52976 6.82177L6.10911 5.41528L5.75439 7.17474Z",
    fill: "#3C41B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJurorFeedback);
export default __webpack_public_path__ + "static/media/JurorFeedback.7815684815f6e91c76fca7136f62e306.svg";
export { ForwardRef as ReactComponent };